import axios from 'axios';
import {BACKEND_URL} from '../constants/ServiceUrl'

export default {
    getAll(){
        return axios.get(BACKEND_URL+'User/getAll.php');
    },
    search(data) {
        return axios.post(BACKEND_URL+'User/search.php', data);
    },
    login(data){
        return axios.post(BACKEND_URL+'User/login.php', data);
    },
    getRoles(){
        return axios.get(BACKEND_URL+'User/getRoles.php');
    },
    add(data){
        return axios.post(BACKEND_URL+'User/add.php', data);
    },
    addOne(data) {
        // return axios.post(BACKEND_URL+'User/addOne.php', data);
        return axios.post(BACKEND_URL+'User/addOneWithHandles.php', data);
    },
    resetPassword(data){
        return axios.put(BACKEND_URL+'User/resetPassword.php',data);
    },
    delete(data){
        return axios.post(BACKEND_URL+'User/delete.php', data);
    },
    activate(data) {
        return axios.put(BACKEND_URL+'User/activate.php',data);
    },
    deactivate(data) {
        return axios.put(BACKEND_URL+'User/deactivate.php',data);
    },
    checkUsername(data) {
        return axios.post(BACKEND_URL+'User/checkUsername.php',data);
    },
    checkEmail(data) {
        return axios.post(BACKEND_URL+'User/checkEmail.php',data);
    },
    checkPassword(data) {
        return axios.post(BACKEND_URL+'User/checkPassword.php',data);
    },
    savePassword(data) {
        return axios.put(BACKEND_URL+'User/savePassword.php',data);
    },
    update(data) {
        return axios.put(BACKEND_URL+'User/update.php',data);
    },
    isTokenValid(data){
        return axios.post(BACKEND_URL+'User/isSessionValid.php',data);
    },
    endSession(data){
        return axios.post(BACKEND_URL+'User/endSession.php',data);
    },
    bulkResetPwdEmail(data) {
        return axios.put(BACKEND_URL+'User/bulkReset.php',data);
    },
    updateUnits(data){
        return axios.put(BACKEND_URL+'User/updateUserUnits.php',data);
    },
    updateHandles(data){
        return axios.put(BACKEND_URL+'User/updateUserHandles.php',data);
    }
}


// WEBPACK FOOTER //
// ./src/api/UserApi.js